module.exports = __webpack_public_path__ + "static/media/dsSpinnerLogo.958f3240.gif";